import { observer } from "mobx-react";
import cn from "classnames";
import { useCallback, useState } from "react";
import { Box } from "@mui/material";
import _get from "lodash/get";
import { useHistory } from "react-router-dom";

import { useLocale } from "src/providers/LocaleProvider";
import { errorService } from "src/service/services";
import { emitter } from "src/shared/emitter";
import paths from "src/consts/paths";
import { LocaleHelper } from "src/shared/helpers/LocaleHelper";
import {
    GameModeCreate,
    ICreateGameRequest,
    ICreateGameRequestNew,
} from "src/service/api/lobby/requestResponses";
import { UserBalanceType } from "src/store/models";
import useStores from "src/hooks/useStores";
import { Switch } from "src/shared/ui/Switch";
import { Button } from "src/shared/ui/Button";
import { useModal } from "src/pages/landing/utils/context";

import { BetSelect } from "../BetSelect";
import { TimeSelect } from "../TimeSelect";
import { RoundSelect } from "../RoundSelect";
import { TypeSelect } from "../TypeSelect";

import { useStyles } from "./styles";

const LobbyHeader = ({ isMatch }) => {
    const { lobbyStore, authStore } = useStores();
    const history = useHistory();
    const locales = useLocale();
    const { openModal } = useModal();
    const {
        common: { newGame },
        lobby: {
            createGame: {
                buttons: { create, match },
            },
        },
    } = useLocale();

    const classes = useStyles();
    const isAuthorized = authStore.isAuthorized;
    const bonus = authStore?.currentUser?.balance.bonus;
    const play = authStore?.currentUser?.balance.play;
    const free = authStore?.currentUser?.balance.coins;

    const isCreateDisabled = lobbyStore.totalActiveGamesCount >= 4;
    const isFreePlay = document.location.href.indexOf("lobby-free-play") > 0;

    const handleCreateGame = useCallback(async () => {

        if (isCreateDisabled) return;
        if (!isAuthorized) return openModal("register");

        await authStore.updateBalanceOnly();
        await new Promise(resolve => setTimeout(resolve, 100)); 

        const updatedBonus = authStore?.currentUser?.balance.bonus;
        const updatedPlay = authStore?.currentUser?.balance.play;
        const updatedFree = authStore?.currentUser?.balance.coins;

        console.log("Updated balances:", { updatedBonus, updatedPlay, updatedFree });

        const isFreePlay = document.location.href.indexOf('lobby-free-play') > 0;
        if (
            isAuthorized &&
            (
                (!updatedPlay && !isFreePlay && !updatedBonus) || 
                (isFreePlay && !updatedFree) 
            )
        ) {
            errorService.sendError("Недостаточно средств для создания игры");
            setTimeout(() => {
                history.push(paths.cashbox); 
            }, 1200); 
            return;
        }


        const createGameParams: ICreateGameRequestNew = {
            bank: lobbyStore.betConfig.value,
            fenType: lobbyStore.gameModeConfig.value,
            freeGame: lobbyStore.lobbyMode === UserBalanceType.play ? 1 : 2,
            gameType: isFreePlay
                ? GameModeCreate.Free
                : lobbyStore.matchConfig.isMatchMode,
            gameCount: lobbyStore.matchConfig.value,
            time: lobbyStore.timeConfig.value,
        };
        if (!createGameParams) {
            errorService.sendError("Please add params");
            throw new Error("Please add params");
        }
        try {
            await lobbyStore.createGameNew(createGameParams);
        } catch (e) {
            errorService.sendError(e.response?.data?.message || "Create error");
        }
    }, [
        lobbyStore.betConfig.value,
        lobbyStore.gameModeConfig.value,
        lobbyStore.lobbyMode,
        lobbyStore.matchConfig.isMatchMode,
        lobbyStore.matchConfig.value,
        lobbyStore.timeConfig.value,
        isAuthorized,
    ]);

    return (
        <Box>
            <div
                className={cn(classes.headerWrapper, {
                    prolimit: !isMatch,
                    isFreePlay: isFreePlay,
                })}
            >
                <BetSelect />
                <TimeSelect />
                <div
                    className={cn(classes.typeRoundUnited, {
                        prolimit: !isMatch,
                        isFreePlay: isFreePlay,
                    })}
                >
                    {!isFreePlay && <RoundSelect isMatch={isMatch} />}
                    <TypeSelect />
                </div>
                <Button
                    text={create("Create")}
                    className={`${classes.createButton} ${
                        isCreateDisabled ? classes.disabledButton : ""
                    }`}
                    onClick={handleCreateGame}
                    disabled={isCreateDisabled}
                />
            </div>
        </Box>
    );
};
export default observer(LobbyHeader);
